export let NewUserModalFieldJSON = {
  "1719383709240-allmultiselect": {
    elementid: 1719383709240,
    elementtype: "allmultiselect",
    "display-fieldlabel": "Mapped User",
    "display-placeholder": "Enter",
    "display-labelposition": "top",
    "database-label": "mapped_userid_list",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
    "display-required": 1,
    "data-customvalue": [],
    "data-datasource": "customvalues",
  },
  "1692362019775-columns": {
    elementid: 1692362019775,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719383722105-customSelect": {
    elementid: 1719383722105,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1719383687656-textfield": {
    elementid: 1719383687656,
    elementtype: "textfield",
    "display-fieldlabel": "IP Address",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383715621-textarea": {
    elementid: 1719383715621,
    elementtype: "textarea",
    "display-fieldlabel": "Description",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
};
